<template>
  <v-container>
        <template>
          <!-- paymentModeFull runs the opposite way to the pair's reading order, so Full is
               the off value here - the control still hands onChnagePaymentMode the same
               boolean the switch did. -->
          <BinaryToggle
            id="protestTaxPaymentModeToggle"
            aria-label="Payment mode: Full or Half"
            off-label="Full"
            :off-value="true"
            on-label="Half"
            :on-value="false"
            :value="paymentModeFull"
            @input="val => onChnagePaymentMode(val)" />
          <ProtestTaxPaymentsList />
                    <div class="d-flex justify-space-between mb-0 mt-10">
            <v-col cols="3" class="mt-n5">
                  <v-row align="center">
                    <v-text-field class="input-text-size" label="Amount Paid Under Protest"
                    v-model.number="amtPaidUnderProtest"/>
                    <v-btn small color="primary"
                    :disabled="!isPickListItemsAvl" @click="handleProtestBreakdown">Apply</v-btn>
                  </v-row>
                </v-col>
                <v-btn small color="primary" :disabled="!isPickListItemsAvl"
                @click="handleReport(false)">Protest Payments Report</v-btn>
            <v-btn small color="primary" @click="handleMakePayment"
            :disabled="!isPickListItemsAvl">Make Payment</v-btn>
              <v-btn small color="primary" :disabled="!isPickListItemsAvl"
              @click="handleReport(true)">Protest Tax Breakdown</v-btn>
            </div>
            <ProtestTaxFundListDialog :baseCrudKey="protestFundCrudKey" />

        </template>
  </v-container>
</template>
<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';
import BinaryToggle from '../../../common/base/BinaryToggle.vue';
import ProtestTaxPaymentsList from './ProtestTaxPaymentsList.vue';
import ProtestTaxFundListDialog from '../../protestTax/ProtestTaxFundListDialog.vue';
import { isProtestFund } from '../../../shared/shared.util';
import { toFiscalYear } from '../../../../util/shared/tmc-global';
import { clients } from '../../../../util/clients';
import { amountToNumber } from '../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import '../../../../assets/style.css';

const { backendRest } = clients.direct;
export default {
  name: 'ProtestTaxPaymentsTab',
  data() {
    return {
      amtPaidUnderProtest: '',
      fiscalYear: toFiscalYear(new Date()),
      protestFundCrudKey: 'ProtestTaxFundList',
      workstation: getWorkstationNumber(),
      modeIndex: 0,
      paymentModeFull: true,
      wkstNumber: getWorkstationNumber(),
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  components: {
    BinaryToggle,
    ProtestTaxPaymentsList,
    ProtestTaxFundListDialog,
  },
  created() {
    this.loadPickListsForProtestTax();
    this.loadFundData();
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'criteria']),
    protestedTaxItemsGetter: {
      get() {
        const itemData = this.items('ProtestTaxPaymentsList');
        if (itemData) return itemData;
        return [];
      },
      set(value) {
        this.setItems(['ProtestTaxPaymentsList', value]);
      },
    },
    itemsGetter() {
      const itemData = this.item('pickListTable');
      return itemData;
    },
    pickListItemsGetter() {
      const itemData = this.items('pickListTable');
      return itemData;
    },
    isPickListItemsAvl() {
      return this.pickListItemsGetter.length > 0;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible', 'setItems', 'setItem',
    ]),
    ...mapMutations('tax/taxInquiryTabs', ['setpaymentMode']),
    ...mapActions('tax/taxInquiryTabs', ['loadPickLists', 'upsertBulkPickList', 'deletePickList', 'deleteAllPickList']),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions(['reAuth']),
    handleAddComments() {
      this.setIsVisible(['pickListAddCommentsDialog', true]);
    },
    onChnagePaymentMode(val) {
      this.paymentModeFull = val;
      this.modeIndex += 1;
      this.handleFullOrHalfPaymentMode();
    },
    loadPickListsForProtestTax() {
      const baseCrudKey = 'ProtestTaxPaymentsList';
      const pickListCriteria = this.criteria(baseCrudKey);
      const criteria = { ...pickListCriteria, workstation: Number(this.workstation) };
      this.loadPickLists({ criteria, baseCrudKey, postProcessTransaction: this.postProccessData });
    },
    async onDeleteRightClick() {
      const item = {
        workstation: Number(this.workstation),
      };
      this.deleteAllPickList({ item, baseCrudKey: 'pickListTable' });
    },
    async onDeleteLeftClick() {
      const item = this.itemsGetter;
      await this.deletePickList({ item, baseCrudKey: 'pickListTable' });
    },
    handleFullOrHalfPaymentMode() {
      const records = this.protestedTaxItemsGetter;
      let updatedRecords;
      if (this.modeIndex <= 1) {
        updatedRecords = records.map((f) => ({
          ...f,
          totalPayment: this.paymentModeFull ? f.totalPayment : f.totalPayment / 2,
          amountPaidNoProtest:
          // eslint-disable-next-line max-len
          (this.paymentModeFull ? f.totalPayment : f.totalPayment / 2) - f.amountPaidUnderProtest,
        }));
      } else {
        updatedRecords = records.map((f) => ({
          ...f,
          totalPayment: this.paymentModeFull ? f.totalPayment * 2 : f.totalPayment / 2,
          amountPaidNoProtest:
          // eslint-disable-next-line max-len
          (this.paymentModeFull ? f.totalPayment * 2 : f.totalPayment / 2) - f.amountPaidUnderProtest,
        }));
      }
      this.protestedTaxItemsGetter = [...updatedRecords];
    },
    async handleProtestBreakdown() {
      const records = this.protestedTaxItemsGetter;
      const tPaymentSign = this.paymentModeFull ? 1 : 2;

      // Calculate the total sum of the amounts
      // eslint-disable-next-line max-len
      const sumOfTotalDue = records.reduce((total, record) => total + (record.totalDue / tPaymentSign), 0);
      const totalBudget = amountToNumber(this.amtPaidUnderProtest);
      let runningTotal = 0;
      // const runningTotal = 0; // To keep track of the sum of rounded values
      // some changes we did this time . previously was using amountStillDue field but unfortunately this field not avl now , so using totalDue field.
      // when add to list from taxinquiry after taht not getting amountStillDue
      const updatedRecords = records.map((record) => {
        const proportion = amountToNumber((record.totalDue / tPaymentSign) / sumOfTotalDue);
        const amountPaidUnderProtest = amountToNumber(totalBudget
         * proportion);
        // eslint-disable-next-line max-len
        const amountPaidNoProtest = amountToNumber((record.totalDue / tPaymentSign)) - amountPaidUnderProtest;
        runningTotal += amountPaidUnderProtest;
        return {
          ...record,
          amountPaidUnderProtest, // Rounded value for each record
          amountPaidNoProtest, // Round to 2 decimal places
          totalPayment: amountPaidUnderProtest + amountPaidNoProtest,
        };
      });
      const difference = (totalBudget - runningTotal);
      if (difference !== 0 && updatedRecords.length > 0) {
        const lastRecord = updatedRecords[updatedRecords.length - 1];
        lastRecord.amountPaidUnderProtest += difference; // Adjust the last record
        lastRecord.amountPaidNoProtest = amountToNumber((lastRecord.totalDue / tPaymentSign)
         - lastRecord.amountPaidUnderProtest);
      }
      const updatedItem = [];
      updatedRecords.forEach((element) => {
        const item = element;
        // delete item.totalPayment;
        delete item.amountStillDue;
        delete item.feeList;
        delete item.statusCodes;
        delete item.taxStillDue;
        updatedItem.push({
          ...item,
          totalPayment: item.amountPaidUnderProtest + item.amountPaidNoProtest,
        });
      });
      await this.upsertBulkPickList({
        item: updatedItem,
        baseCrudKey: 'pickListTable',
      }).then(() => {
        this.loadPickListsForProtestTax();
      });
    },
    async postProccessData(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        item.amountStillDue = Math.abs(item.totalDue - item.totalPaid);
        updatedItems.push(item);
      }
      return updatedItems;
    },

    loadFundData() {
      this.loadFunds({
        criteria: {
          fiscalYear: this.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedFund',
      });
    },
    urlEncodeObject(obj) {
      return new URLSearchParams(obj).toString();
    },
    async handleReport(isBreakdown) {
      let toUrl;
      let apportionUrl;
      const { jwt } = await this.reAuth();
      const criteria = {
        wkstID: this.wkstNumber,
        token: jwt,
      };
      if (!isBreakdown) {
        toUrl = `${backendRest.defaults.baseURL}/taxInquiry/protest-tax-payment-reports?${this.urlEncodeObject(criteria)}`;
      } else {
        toUrl = `${backendRest.defaults.baseURL}/taxInquiry/protest-tax-payment-breakdown-reports?${this.urlEncodeObject(criteria)}`;
        apportionUrl = `${backendRest.defaults.baseURL}/taxInquiry/protest-tax-payment/apportionmentReport?${this.urlEncodeObject(criteria)}`;
        window.open(apportionUrl);
      }
      window.open(toUrl);
    },

    async  handleMakePayment() {
      const items = this.items('sharedFund');
      const funds = items.filter((f) => isProtestFund(parseInt(f.fund, 10)));
      this.setItems(['sharedFund', funds]);
      this.setIsVisible([this.protestFundCrudKey, true]);
    },
  },

};
</script>
